import Immutable from 'seamless-immutable';
import { AnyAction } from 'redux';
import {
  DISABLE_ARE_YOU_STILL_WATCHING,
  SHOW_ARE_YOU_STILL_WATCHING,
  HIDE_ARE_YOU_STILL_WATCHING,
} from 'actions/areYouStillWatching';
import { AreYouStillWatching } from 'store-types';

const INITIAL_STATE = Immutable({
  disabled: false,
  showDialog: false,
});

export default (state: Immutable.ImmutableObject<AreYouStillWatching> = INITIAL_STATE, action: AnyAction) => {
  switch (action.type) {
    case DISABLE_ARE_YOU_STILL_WATCHING:
      return state.merge({ disabled: true });
    case SHOW_ARE_YOU_STILL_WATCHING:
      return state.merge({ showDialog: true });
    case HIDE_ARE_YOU_STILL_WATCHING:
      return state.merge({ showDialog: false });
    default:
      return state;
  }
};
